<div class="checkbox" (click)="toggle()" [ngClass]="type">
    <input type="checkbox" [(ngModel)]="checked" />
    <span class="checkmark" [ngClass]="{ checked: checked }">
        <app-icon *ngIf="checked" [type]="'Check'"></app-icon>
    </span>
</div>
